module.exports = __webpack_public_path__ + "static/media/12.5435357a.svg";